import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'grid-mosaico-item',
  template: `
    <div class="grid-mosaico-lista-item-conteudo">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .grid-mosaico-lista-item-conteudo {
      display: inline-block;
      width: 100%;
    }
    @media (max-width: 410px) {
      .grid-mosaico-lista-item-conteudo {
        margin-bottom: 10px;
      }
    }
  `]
})
export class GridMosaicoItemComponent {

  @HostBinding('class') elementClass = 'grid-mosaico-lista-item';

  constructor() {}

}
